import FeatureIcon from "./FeatureIcon";

const COLOR_RING = {
  lime: "from-[var(--primary)]/25 to-transparent",
  cyan: "from-cyan-400/20 to-transparent",
  violet: "from-violet-400/20 to-transparent",
};

export default function ProductShowcase({ showcase }) {
  if (!showcase?.categories?.length) return null;

  return (
    <section id="platform" className="py-20 md:py-28 border-y border-[var(--border-default)] relative overflow-hidden">
      <div className="absolute inset-0 dot-grid opacity-20 pointer-events-none" />
      <div className="max-w-[1320px] mx-auto px-4 md:px-8 relative">
        <div className="max-w-3xl">
          <div className="landing-section-kicker mb-4">{showcase.overline}</div>
          <h2 className="font-heading text-3xl md:text-5xl tracking-tight font-medium leading-[1.08]">
            {showcase.title}{" "}
            <span className="text-[var(--text-tertiary)]">{showcase.titleMuted}</span>
          </h2>
          {showcase.subtitle ? (
            <p className="mt-5 text-lg text-[var(--text-secondary)] leading-relaxed">{showcase.subtitle}</p>
          ) : null}
        </div>

        <div className="mt-14 space-y-16">
          {showcase.categories.map((cat) => (
            <div key={cat.id || cat.title}>
              <div className="flex items-center gap-3 mb-6">
                <span
                  className={`h-px flex-1 max-w-[48px] bg-gradient-to-r ${COLOR_RING[cat.color] || COLOR_RING.lime}`}
                />
                <h3 className="font-heading text-xl md:text-2xl tracking-tight">{cat.title}</h3>
              </div>
              <div className="grid md:grid-cols-3 gap-4">
                {(cat.items || []).map((item) => (
                  <article
                    key={item.title}
                    className="landing-product-card group relative overflow-hidden p-6 md:p-7"
                  >
                    <div className="landing-product-card-glow" aria-hidden />
                    <div className="relative">
                      <div className="flex items-start justify-between gap-3">
                        <span className="landing-product-icon">
                          <FeatureIcon name={item.icon} size={22} />
                        </span>
                        {item.metric ? (
                          <span className="font-mono text-[10px] uppercase tracking-wider text-[var(--primary)] shrink-0">
                            {item.metric}
                          </span>
                        ) : null}
                      </div>
                      <h4 className="font-heading text-lg mt-5 leading-snug">{item.title}</h4>
                      <p className="text-sm text-[var(--text-secondary)] mt-2 leading-relaxed">{item.body}</p>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
